<template>
    <div>
        <b-row>
            <b-col cols="6">
                <app-form-input
                    placeholder="Nombre"
                    id="venue"
                    v-model="filters.name"
                ></app-form-input>
            </b-col>
            <b-col cols="auto">
                <b-btn variant="primary" @click="filter"
                    ><i class="fa fa-filter"></i
                ></b-btn>
                <b-btn variant="secondary" @click="clear"
                    ><i class="fa fa-times"></i
                ></b-btn>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    data: () => ({
        filters: {
            name: '',
        },
    }),
    computed: {
        //
    },
    methods: {
        filter() {
            this.$emit('filter', this.filters)
        },
        clear() {
            this.filters.name = ''
            this.$emit('filter', null)
        },
    },
}
</script>
